/**
 * @file app入口文件
 */

import Vue from 'vue';
import App from './LoginApp.vue';
import 'element-ui/lib/theme-chalk/index.css';
import '@/common/less/common.less';
import ElementUI from 'element-ui';

import {
    router
} from './router';

Vue.config.productionTip = false;
Vue.use(ElementUI);

new Vue({
    router,
    render: h => h(App)
}).$mount('#app');
